export { default as Login } from './Login'
export { default as ForgotPassword } from './ForgotPassword'
export { default as ResetPassword } from './ResetPassword'
export { default as Register } from './Register'
export { default as Account } from './Account'
export { default as Webhook } from './Webhook'
export { default as Submenu } from './Submenu'
export { default as User } from './User'
export { default as Users } from './Users'



// WEBPACK FOOTER //
// ./scripts/components/views/account/index.js